module.exports = __webpack_public_path__ + "static/media/tip-5.8b58e79b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/tip-5.jpeg
// module id = 541
// module chunks = 0